import { messageCountLoadEpicReducer, messageCountReducer, messageCountReducerStateDefault } from "./messageCount.duck.js";
import { messageListLoadEpicReducer, messageListReducer, messageListReducerStateDefault } from "./messageList.duck.js";
import { messageDismissEpicReducer, messageDismissReducer, messageDismissReducerStateDefault } from "./messageDismiss.duck.js";
import { messageDismissAllEpicReducer, messageDismissAllReducer, messageDismissAllReducerStateDefault } from "./messageDismissAll.duck.js";
import { upsellMessageListLoadEpicReducer } from "./upsellMessageList.duck.js";
import { upsellMessageListReducer, upsellMessageListReducerStateDefault } from "./upsellMessageList.duck.js";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { reduxActionTypePrefix, reduxKeys } from "../constants/constants.js";
import MessagesResource from "../resources/Messages.resource.js";
const actionTypesPrefix$1 = reduxActionTypePrefix + "/dismissUpsellMessage";
const upsellMessageDismissEpicReducerArg = {
  actionPrefix: actionTypesPrefix$1,
  reduxKeyNested: () => [reduxKeys.value],
  loadResource: (request) => MessagesResource.dismissUpsellMessage(request.workspaceId, request.upsellNotificationId),
  onCompleteSuccess: (dismissResult, inputPayload) => (dismissResult == null ? void 0 : dismissResult.Value) || 0,
  afterActionsOnSuccess: (inputPayload, outputPayload) => loadMessagesAndRefreshCount$1(inputPayload, outputPayload)
};
const upsellMessageDismissEpicReducer = loadResourcesUtils(upsellMessageDismissEpicReducerArg);
const loadMessagesAndRefreshCount$1 = (inputPayload, outputPayload) => [
  upsellMessageListLoadEpicReducer.actionCreators.load({
    workspaceId: inputPayload.workspaceId,
    loadCount: inputPayload.loadCount,
    lastMessageId: inputPayload.lastMessageId
  })
];
const upsellMessageDismissReducerStateDefault = {
  value: getDefaultAsyncWrapperObj()
};
const upsellMessageDismissReducer = (state = upsellMessageDismissReducerStateDefault, action) => {
  state = upsellMessageDismissEpicReducer.reduxChange(state, action);
  return state;
};
const actionTypesPrefix = reduxActionTypePrefix + "/dismissAllUpsellMessages";
const upsellMessageDismissAllEpicReducerArg = {
  actionPrefix: actionTypesPrefix,
  reduxKeyNested: () => [reduxKeys.value],
  loadResource: (request) => MessagesResource.dismissAllUpsellMessages(request.workspaceId),
  onCompleteSuccess: (dismissResult, inputPayload) => (dismissResult == null ? void 0 : dismissResult.Value) || 0,
  afterActionsOnSuccess: (inputPayload, outputPayload) => loadMessagesAndRefreshCount(inputPayload, outputPayload)
};
const upsellMessageDismissAllEpicReducer = loadResourcesUtils(upsellMessageDismissAllEpicReducerArg);
const loadMessagesAndRefreshCount = (inputPayload, outputPayload) => [
  upsellMessageListLoadEpicReducer.actionCreators.load({
    workspaceId: inputPayload.workspaceId,
    loadCount: 0,
    lastMessageId: inputPayload.lastMessageId
  })
];
const upsellMessageDismissAllReducerStateDefault = {
  value: getDefaultAsyncWrapperObj()
};
const upsellMessageDismissAllReducer = (state = upsellMessageDismissAllReducerStateDefault, action) => {
  state = upsellMessageDismissAllEpicReducer.reduxChange(state, action);
  return state;
};
export {
  messageCountLoadEpicReducer,
  messageCountReducer,
  messageCountReducerStateDefault,
  messageDismissAllEpicReducer,
  messageDismissAllReducer,
  messageDismissAllReducerStateDefault,
  messageDismissEpicReducer,
  messageDismissReducer,
  messageDismissReducerStateDefault,
  messageListLoadEpicReducer,
  messageListReducer,
  messageListReducerStateDefault,
  upsellMessageDismissAllEpicReducer,
  upsellMessageDismissAllReducer,
  upsellMessageDismissAllReducerStateDefault,
  upsellMessageDismissEpicReducer,
  upsellMessageDismissReducer,
  upsellMessageDismissReducerStateDefault,
  upsellMessageListLoadEpicReducer,
  upsellMessageListReducer,
  upsellMessageListReducerStateDefault
};
//# sourceMappingURL=index.js.map
